import {Routing} from 'nutshell-core/routing';

import type {ActionableHeaderStatusBadgeProps} from 'shells/actionable-header/actionable-header';
import {StarRegularIcon} from 'shells/icon/svg/star-regular-icon';

import type {StagesetStarterType, StagesetStatus} from 'nutshell-graphql-types';
import type {GetStagesetsUnarchived_stagesets as StagesetUnarchived} from 'nutshell-graphql-types';

import type {StagesetStarterCategory} from './types';

export function getPipelineModalSaveButtonText(
    selectedCategory: StagesetStarterCategory,
    selectedStageset?: StagesetUnarchived | null
) {
    if (selectedCategory.id === 'START_FROM_SCRATCH') {
        return 'Start from scratch';
    }

    if (selectedCategory.id === 'COPY_EXISTING') {
        if (selectedStageset) {
            return `Start from ${selectedStageset.name}`;
        }

        return 'Copy this pipeline';
    }

    return `Start from ${getPipelineName(selectedCategory)}`;
}

export const getPipelineName = (category: StagesetStarterCategory) => {
    if (category.collection && category.collection[0]) {
        return category.collection[0].name;
    }

    return 'template';
};

export function getPreviewGraphicUrl(type: StagesetStarterType | 'START_FROM_SCRATCH'): string {
    switch (type) {
        case 'ENTERPRISE_SALES':
            return '/include/images/starter-packs/enterprise-sales.svg';
        case 'FAST_TOUCH_INBOUND':
            return '/include/images/starter-packs/fast-touch-inbound.svg';
        case 'OUTBOUND_PROSPECTING':
            return '/include/images/starter-packs/outbound-prospecting.svg';
        case 'QUOTE_AND_INVOICE_SELLING':
            return '/include/images/starter-packs/quote-invoice-selling.svg';
        case 'RENEWALS':
            return '/include/images/starter-packs/renewals.svg';
        case 'START_FROM_SCRATCH':
            return '/include/images/starter-packs/blank-pipeline.svg';
        default:
            return '/include/images/starter-packs/blank-pipeline.svg';
    }
}

export function getPipelineStatusBadge(
    status: StagesetStatus,
    isDefault: boolean,
    isArchived: boolean
): ActionableHeaderStatusBadgeProps | null | undefined {
    if (isDefault) {
        return {
            text: 'Default',
            level: 'success',
            customIcon: StarRegularIcon,
        };
    }

    switch (status) {
        case 'ACTIVE':
            return {text: 'Active', level: 'success'};
        case 'RETIRED':
            return isArchived
                ? {text: 'Archived', level: 'hidden'}
                : {text: 'Draft', level: 'info'};
        case 'DRAFT':
        default:
            return {text: 'Draft', level: 'info'};
    }
}

export function getLeadsListLink(stagesetId: string) {
    const filter = Routing.param({
        filter: {
            status: {anyAll: 'any', data: [{data: 'Open'}]},
            stageset: {anyAll: 'any', data: [{data: stagesetId}]},
        },
    });

    return `/leads?${filter}&view=list`;
}
